import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { MarkStatus } from '@submissions/v1/models';
import {
  BulkUpdateTaskStatusByIdsPayload,
  BulkUpdateTaskStatusPayload,
  SMEQCTaskListPayload,
  TaskEvents,
  TaskInstance,
  UpdateTaskInListPayload,
  UpdateTaskStatusPayload,
} from '../../types';
export const TASK_EVENTS: TaskEvents = eventGroup({
  events: {
    bulkUpdateTaskStatus: type<BulkUpdateTaskStatusPayload>(),
    bulkUpdateTaskStatusByIds: type<BulkUpdateTaskStatusByIdsPayload>(),
    exportAllThreads: type<{ workspaceID: string }>(),
    getRemainingToDoTaskCount: type<{ workspaceID: string }>(),
    getSMEQCTaskList: type<SMEQCTaskListPayload>(),
    getSMEQCTaskListByIds: type<SMEQCTaskListPayload>(),
    getTaskList: type<{ workspaceID: string; submissionStage: string }>(),
    taskListLoaded: type<{ taskList: TaskInstance[] }>(),
    patchDocumentTaskList: type<{ taskList: TaskInstance[] }>(),
    patchQuestionTaskList: type<{ taskList: TaskInstance[] }>(),
    patchSectionTaskList: type<{ taskList: TaskInstance[] }>(),
    patchTaskList: type<{ taskList: TaskInstance[] }>(),
    updateSMEQCMARK: type<{
      workspaceId: string;
      sectionId: string;
      markStatus: MarkStatus;
    }>(),
    updateTaskInList: type<UpdateTaskInListPayload>(),
    updateTaskListFiltered: type<{ filtered: boolean }>(),
    updateTaskStatus: type<UpdateTaskStatusPayload>(),
    resetTaskListState: type<void>(),
  },
  source: 'Task Signal Store',
});
